module.exports = __webpack_public_path__ + "static/media/wellness.ac64a645.png";